var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z",
  fill: "#45B12E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m6.775 9.758 4.32-4.32a.366.366 0 0 1 .26-.113c.1-.002.189.036.266.114a.368.368 0 0 1 .117.267c0 .1-.04.19-.117.267l-4.53 4.538a.434.434 0 0 1-.316.135.434.434 0 0 1-.316-.135L4.37 8.423a.357.357 0 0 1-.11-.265c.001-.102.04-.192.118-.27a.367.367 0 0 1 .267-.116c.1 0 .19.039.268.117l1.861 1.869Z",
  fill: "#fff"
})));

export default SvgCheckCircle;